var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSubscriptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0f4b73;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-983 -417)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(983 417)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(994.5 428)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.5,6h27a3,3,0,0,1,3,3V27a3,3,0,0,1-3,3H4.5a3,3,0,0,1-3-3V9a3,3,0,0,1,3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.5,15h33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubscriptions);
export default __webpack_public_path__ + "static/media/icon-Subscriptions.b7092b29f6c5a22099b84ae1cc363f99.svg";
export { ForwardRef as ReactComponent };